<template lang="pug">
  div
    div(v-if="loading")
      .loading
        .loadingIcon
          img.loading-spin(src='/static/loading-cicle.png')
          //- .loading-spin
          //-   .big-cicle
          //-     .small-cicle
          //-       .ball
          //- .sr-only Loading...
          i.icon.DYT_icon_font.icon-dianyitonglogo_lan
          .loadingText 加载中
            span(v-for="i in num%4" :key="i") .
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      num: 1,
      interval: null
    }
  },
  created() {
    this.interval = setInterval(() => {
      this.num++
    }, 500)
  },
  computed: {
    ...mapState({
      loading: (state) => state.app.onLoading
    })
  },
  updated() {
    if (!this.loading) {
      clearInterval(this.interval)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';

@keyframes myfirst {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.loading-spin {
  width: 2rem;
  height: 2rem;
  text-align: center;
  animation: myfirst 0.8s linear infinite;
  .big-cicle {
    width: 1.7rem;
    height: 1.7rem;
    background: linear-gradient(to left top, #ffffff, #7e7e7e);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
  }
  .small-cicle {
    position: relative;
    width: 86%;
    height: 86%;
    background: #434859;
    border-radius: 100%;
  }
  .ball {
    width: 0.6em;
    height: 0.6em;
    background-color: #fff;
    border-radius: 50%;
    position: absolute;
    bottom: 0.3em;
    left: 0;
    border: 1px solid #7e7e7e;
  }
}

.loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 50;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .loadingIcon {
    position: relative;
    background-color: #434859;
    border-radius: 5%;
    padding: 1.4em 2em;
    font-size: 0.4rem;
    color: #fff;
    .icon-dianyitonglogo_lan {
      font-size: 2em;
      color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -0.5em;
      margin-top: -1.1em;
    }
    .loadingText {
      margin-top: 0.4rem;
      text-align: center;
    }
  }
}
</style>
